'use strict';

module.exports = {
    OK_200: 200,
    NO_CONTENT_204: 204
};
